/**
 * Maps a granite color (by ID or name) to its granite family:
 * - 'PJB'  = Premium Jet Black family (dark stones: laser-only artwork)
 * - 'GREY' = Grey/light stone family (sandblast artwork)
 *
 * MW color ID reference (from arrColorDet):
 *   5  = Premium Jet Black (PJB)
 *   6  = Silver Pearl (GREY family)
 *   8  = Paradiso (GREY family)
 *   12 = Medium Gray (GREY)
 *   14 = Mist Black (PJB - dark stone)
 *   15 = Imperial Pink (GREY family)
 *   23 = Tan Brown (GREY family)
 *   36 = India Red (GREY family)
 */
export const getGraniteForColor = (colorId: number | null, colorName?: string): string => {
  if (colorName) {
    const name = colorName.toLowerCase();
    if (name.includes('grey') || name.includes('gray')) return 'GREY';
    if (name.includes('black') || name.includes('pjb')) return 'PJB';
  }

  // Fallback to IDs if name doesn't match
  if (colorId === 5 || colorId === 14) return 'PJB';
  if (colorId === 12) return 'GREY';

  // Default: all other colors behave like non-PJB (Sandblast).
  // This prevents the Art panel from showing both granite options when a color
  // doesn't include "grey/black" in its name (e.g. "India Red", "Bahama Blue").
  return 'GREY';
};